import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { HttpClient } from './http-client';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { dateToUnixTime } from "../utils/DateHelper";

@Injectable()
export class DashboardService {

    constructor(private httpClient: HttpClient) {

    }

    getConsignasHoy(){
        let userId = localStorage.getItem('userId');

        return this.httpClient.get(`/api/dashboard/consignas-hoy/${userId}/3/0`)
            .map((response: Response) => {
                return response.json();
            });
    }

    getLogrosColaboradores(page: number = 0, size: number = 5){
        let userId = localStorage.getItem('userId');
        
        return this.httpClient.get(`/api/dashboard/colaboradores-logros/${userId}/${size}/${page}`)
            .map((response: Response) => {
                return response.json();
            });
    }

    getMiEvolucion(start, end){
        let userId = localStorage.getItem('userId');
        
        return this.httpClient.get(`/api/dashboard/mi-evolucion/${userId}/${start}/${end}`)
            .map((response: Response) => {
                return response.json();
            });
    }

    getMiContribucion(){
        let userId = localStorage.getItem('userId');
        
        return this.httpClient.get(`/api/dashboard/mi-contribucion/${userId}`)
            .map((response: Response) => {
                return response.json();
            });
    }


    getColaboradoresCercanos(){
        let userId = localStorage.getItem('userId');

        return this.httpClient.get(`/api/dashboard/colaboradores-cercanos/${userId}/`)
            .map((response: Response) => {
                return response.json();
            });
    }

    getCuentasCercanas(){
        let userId = localStorage.getItem('userId');

        return this.httpClient.get(`/api/dashboard/empresas-cercanas/${userId}/`)
            .map((response: Response) => {
                return response.json();
            });
    }

    getConsignasByContacto(page: number = 0, size: number = 4){
        let userId = localStorage.getItem('userId');
        
        return this.httpClient.get(`/api/dashboard/contactos-consignas/${userId}/${size}/${page}`)
            .map((response: Response) => {
                return response.json();
            });
    }

    getConsignasByEmpresa(page: number = 0, size: number = 4){
        let userId = localStorage.getItem('userId');
        
        return this.httpClient.get(`/api/dashboard/empresas-consignas/${userId}/${size}/${page}`)
            .map((response: Response) => {
                return response.json();
            });
    }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/dashboard-service.ts